import { SaveRepresentativesPayload } from '~services/types';
import { omitBy, isNil } from 'lodash';
import { Form, Forms } from './types';
import moment from 'moment';
import { formatFileToBase64 } from '~utils/formatters';

const formatRepresentative = (form: Form) => {
  const optionalFields = omitBy(
    {
      cpf: form.values?.cpf?.replace(/[^0-9]/g, ''),
      birthday_date: moment(form.values?.birthdayDate, 'DD/MM/YYYY').format(
        'YYYY-MM-DD'
      ),
      mother_name: form.values?.motherName,
      declared_income: Number(form.values.declaredIncome),
      politically_exposed_person: form.values?.politicallyExposedPerson,
      address: {
        zip_code: form.values?.zipCode?.replace(/[^0-9]/g, ''),
        number: form.values?.number,
        state: form.values?.state,
        city: form.values?.city,
        neighborhood: form.values?.neighborhood,
        street: form.values?.street,
        complement: form.values?.complement,
      },
    },
    isNil
  );

  const haveOptionalFields = form.values?.allFields && optionalFields;

  return {
    name: form.values?.name,
    email: form.values?.email,
    is_complete: form.status === 'concluído',
    cellphone: form.values?.cellphone.replace(/[^0-9]/g, ''),
    type: form?.type,
    ...haveOptionalFields,
  };
};

export const formatPayload = async (
  forms: Forms
): Promise<SaveRepresentativesPayload> => {
  const [primary] = forms;

  const representatives = forms.map((form) => {
    return formatRepresentative(form);
  });

  return {
    social_contract: primary.values.socialContract,
    representatives,
  };
};
